import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const Card = ({ category }) => {
  return (
    <Component>
      <h3>
        {" "}
        <Link to={`/category/${category.categories_id}`}>
          {category.title }
        </Link>{" "}
      </h3>
      <Link to={`/category/${category.categories_id}`}>
        <img src={category.image_name } alt="" />
      </Link>
    </Component>
  );
};

export default Card;

const Component = styled.div`
  height: 280px;
  width: 280px;
  background: #ffffff;
  border: 1px solid pink;
  border-radius: 10px;
  padding: 17px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  @media (max-width: 1011px) {
    width: 240px;
    height: 240px;
  }
  @media (max-width: 914px) {
    width: 200px;
    height: 200px;
  }

  @media (max-width: 800px) {
    width: 170px;
    height: 170px;
  }
  @media (max-width: 660px) {
    width: 140px;
    height: 140px;
  }

  @media (max-width: 580px) {
    width: 110px;
    height: 110px;
    border-radius: 4px;
  }

  @media (max-width: 470px) {
    width: 140px;
    height: 140px;
  }
  @media (max-width: 400px) {
    width: 120px;
    height: 120px;
  }

  a {
    text-decoration: none;
    color: black;

    
  }
  h3 {
    width: 100%;
    text-align: left;
    @media (max-width: 1011px) {
      font-size: 15px;
    }
    @media (max-width: 800px) {
      font-size: 12px;
    }
    @media (max-width: 660px) {
      font-size: 10px;
    }
    @media (max-width: 580px) {
      font-size: 9px;
    }
    @media (max-width: 470px) {
      width: 120%;
      font-size: 12px;
    }
    @media (max-width: 430px) {
      font-size: 11px;
    }
  }

  img {
    height: 240px;
    @media (max-width: 1011px) {
      height: 180px;
    }
    @media (max-width: 800px) {
      height: 140px;
    }
    @media (max-width: 660px) {
      height: 210px;
    }
    @media (max-width: 470px) {
      height: 200px;
    }
    @media (max-width: 430px) {
      height: 120px;
    }
  }
`;
